import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/php';
import comment from '../../snippets/comment';
import {locales} from '../sampleLocations';
import {CreateShellCommand} from '../../../components/left-col';

const createLocation = (country) => {
  const location = locales[country].location;
  const state = location.address.state
    ? `
      'state' => "${location.address.state}",`
    : '';
  return `
function createLocation() {
  {+create-location}
  $location = \\Stripe\\Location::create([
    'display_name' => '${location.displayName}',
    'address' => [
      'line1' => "${location.address.line1}",
      'city' => "${location.address.city}",${state}
      'country' => "${location.address.country}",
      'postal_code' => "${location.address.postalCode}",
    ]
  ]);
  {/create-location}

  return location;
}
`;
};

export const steps = {
  setup,
  'create-location': {},
  'connection-token-endpoint': {},
  'create-intent': {},
  'capture-intent-endpoint': {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.terminal.server.php.run-server.body',
        defaultMessage: 'Run your server and go to <a>localhost:4242</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant, reader, country}) => `<?php

require 'vendor/autoload.php';

{+setup}
${comment && comment(merchant)}
\\Stripe\\Stripe::setApiKey('${keys.secret}');
{/setup}
${createLocation(country)}
header('Content-Type: application/json');

try {
  // The ConnectionToken's secret lets you connect to any Stripe Terminal reader
  // and take payments with your Stripe account.
  // Be sure to authenticate the endpoint for creating connection tokens.
  {+connection-token-endpoint}
  {span response connection-token-endpoint}$connectionToken{/span} = \\Stripe\\Terminal\\ConnectionToken::create();
  echo json_encode(array('secret' => $connectionToken->secret));
  {/connection-token-endpoint}

} catch (Error $e) {
  http_response_code(500);
  echo json_encode(['error' => $e->getMessage()]);
}`;
